<!-- <template>
	<div class="module_container full" style="position: relative;">
		<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:ref="moduleName+'_list'" :foreingKey="foreingKey">

		</vxe-grid>

		<component :is="formModule.component" v-if="formModule.show" :name="formModule.name" :id="formModule.id"
			:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
			@back="formBack" />

	</div>
</template>
<style>

</style>
<style scoped>

</style> -->
<script>
	import listBase from '@_system/components/base/list.vue'

	export default {
		extends: listBase,
		name: 'invoiceauditIndex',
		props: {
			foreingKey: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				moduleName: 'invoiceaudit',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			add() {
				import('@/components/forms/finance/invoiceaudit/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'invoiceaudit',
						id: 0,
						controlltype: 1,
						show: true,
						foreingKey:this.foreingKey
					}
				})
			},
			edit(row) {
				import('@/components/forms/finance/invoiceaudit/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'invoiceaudit',
						id: row.id,
						controlltype: 2,
						show: true,
					}
				})
			}
		},
		components: {

		}
	}
</script>
